import script from "./MarketplaceVolumeChart.vue?vue&type=script&setup=true&lang=js"
export * from "./MarketplaceVolumeChart.vue?vue&type=script&setup=true&lang=js"

import "./MarketplaceVolumeChart.vue?vue&type=style&index=0&id=3a58da6d&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a58da6d"]])

export default __exports__